import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import CulpabilityServices from "services/Culpability";

export const addNewCulpability = createAsyncThunk(
  "/culpability/new",
  async (formData) => {
    const res = await CulpabilityServices.addNewCulpabilityApi(formData);
    return res.data;
  }
);

export const fetchAllCulpability = createAsyncThunk(
  "/culpability/all",
  async ({ page, limit, status, search, startDate, endDate, issueId }) => {
    const res = await CulpabilityServices.getAllCulpabilityApi(
      page,
      limit,
      status,
      search,
      startDate,
      endDate,
      issueId
    );
    return res.data;
  }
);
export const fetchSingleCulpability = createAsyncThunk(
  "/culpability/details",
  async ({ id }) => {
    const res = await CulpabilityServices.getSingleCulpability(id);
    return res.data;
  }
);
export const updateCulpability = createAsyncThunk(
  "/culpability/update",
  async ({ id, data }) => {
    const res = await CulpabilityServices.updateCulpabilityApi(id, data);
    return res.data;
  }
);
export const deleteFiles = createAsyncThunk(
  "/culpability/delete_files",
  async ({ id, data }) => {
    const res = await CulpabilityServices.deleteFilesApi(id, data);
    return res.data;
  }
);
export const deleteCulpability = createAsyncThunk(
  "/culpability/delete",
  async ({ id }) => {
    const res = await CulpabilityServices.deleteApi(id);
    return res.data;
  }
);

export const clearSavedId = createAsyncThunk(
  "clearId",
  async ({ createdId }) => {
    return createdId;
  }
);

export const clearDeletedArray = createAsyncThunk(
  "deleted",
  async ({ deleted }) => {
    return deleted;
  }
);
const culpabilitySlice = createSlice({
  name: "culpability",
  initialState: {
    loading: false,
    allCulpabilityData: [],
    total: null,
    totalPages: 1,
    details: {},
    createdId: null,
    deleted: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(addNewCulpability.pending, (state) => {
        state.loading = true;
      })
      .addCase(addNewCulpability.fulfilled, (state, action) => {
        state.loading = false;
        state.createdId = action.payload.data.id;
        toast.success("Culpability submitted sucessfully");
      })
      .addCase(addNewCulpability.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to create new culpability.");
      })
      .addCase(updateCulpability.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCulpability.fulfilled, (state, action) => {
        state.loading = false;
        state.createdId = action.payload.data.id;
        toast.success("Culpability Updated sucessfully");
      })
      .addCase(updateCulpability.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(fetchAllCulpability.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllCulpability.fulfilled, (state, action) => {
        state.loading = false;
        state.allCulpabilityData = action.payload.data;
        state.total = action.payload.total;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchAllCulpability.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(fetchSingleCulpability.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSingleCulpability.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload.data;
      })
      .addCase(fetchSingleCulpability.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload.data;
        state.deleted = true;
        toast.success("Selected files deleted sucessfully");
      })
      .addCase(deleteFiles.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to delete files");
      })
      .addCase(deleteCulpability.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteCulpability.fulfilled, (state, action) => {
        state.loading = false;
        toast.success("Culpability Deleted sucessfully");
      })
      .addCase(deleteCulpability.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to delete Culpability.");
      })

      .addCase(clearSavedId.fulfilled, (state, action) => {
        state.createdId = null;
      })
      .addCase(clearDeletedArray.fulfilled, (state, action) => {
        state.deleted = false;
      });
  },
});

const { reducer } = culpabilitySlice;
export default reducer;
